import React from 'react';

const InvoiceStatusBadge = ({ status }) => {
    const colors = {
        draft: 'bg-[#FFF1E2] !text-[#E77C00]',
        sent: 'bg-blue-50 !text-blue-500',
        paid: 'bg-green-50 !text-green-500',
        overdue: 'bg-red-50 !text-red-500',
    };

    status = status || '';

    return (
        <span className={`tag ${colors[status] || colors.draft}`}>
            {status.toUpperCase()}
        </span>
    );
};

export default InvoiceStatusBadge;

